import { defineComponent } from 'vue'

export default defineComponent({
  name: 'EditIconBtn',
  setup() {
    return {}
  },
})
